import { useQuery } from "@tanstack/react-query";

import { APP_SETTINGS_CACHE_KEYS } from "./keys";

import { AppSettingsRepository } from "@/repositories/app-settings";

const appSettingsRepository = new AppSettingsRepository();

export const useGetAppSettings = () => {
  return useQuery({
    queryKey: APP_SETTINGS_CACHE_KEYS.DETAIL,
    queryFn: () => appSettingsRepository.find(),
  });
};
